import { TaskService, TaskTypes, TaskStatus } from '../../../../../../v2-node-api/services/task.service';
import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {API_URLS} from 'src/environments/env-routes';
import {APIHelper} from 'src/shared/services/api-helper/api-helper.service';
import {UserService} from '../../../../../../../shared/services/user/user.service';
import { StorageService } from 'src/shared/services/storage/storage.service';

@Component({
  selector: 'dialog-export-folder',
  templateUrl: './dialog-export-folder.component.html',
  styleUrls: ['./dialog-export-folder.component.css']
})
export class DialogExportFolderComponent implements OnInit {

  public selectedId: string;
  public loading: boolean;
  public file: any;
  public actualPercent: number;
  public bitsLoaded: number;
  public bitsTotal: number;
  public isPublic: boolean;
  public name: string;
  public lastError: string;
  private stop: boolean;
  private actualTimeout;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<DialogExportFolderComponent>,
              private api: APIHelper,
              protected taskService: TaskService,
              protected userService: UserService,
              private storage: StorageService
  ) {
  }

  ngOnInit(): void {
    this.actualTimeout = null;
    this.stop = false;
    this.actualPercent = 0;
    this.loading = true;

    this.selectedId = this.data.siteId;


    const data = {
      nodeRef: 'workspace://SpacesStore/' + this.selectedId
    };
    const datas = [data];

    this.api.requestApi({action: API_URLS.sites.export, method: 'POST', datas: datas}).then((res) => {
      this.loading = false;
      this.name=res.siteId;
      const id = /[^/]*$/.exec(res.nodeRef)[0];
      this.taskService.create({
        'creator': this.userService.user.id,
        'type': TaskTypes.ExportSite,
        'startedAt': new Date(),
        'status': TaskStatus.Pending,
        'data': {
          'siteId': res.siteId,
          'DownloadState': {'id': id}
        }
      }).subscribe(t => {
     
      });
      this.recursiveCheckDownload(id);
    }).catch(err => {
      this.lastError =
        'Erreur d\'exportation ';
    })
      .finally(() => (this.loading = false));
  }

  private recursiveCheckDownload(id: string) {

    let url ="";
    this.api
      .requestApi({
        action: API_URLS.nodes.downloadsState.replace(':id', id)
      })
      .then(res => {

      
        if (res.filesAdded) {
          this.bitsTotal = res.totalBytes;
          this.bitsLoaded = res.bytesAdded;
          this.actualPercent = Math.round(
            (this.bitsLoaded / this.bitsTotal) * 100
          );
        }

        if (this.stop) {
          return;
        } else if (res.status !== 'DONE') {
          // Attendre 1/2 secondes et relancer le call
          this.actualTimeout = setTimeout(() => {
            this.recursiveCheckDownload(id);
          }, 500);

        } else {
        
          const token = this.storage.getAsync({key: 'token'});
         
           url = this.api.url + API_URLS.nodes.downloadContentZip.replace(':id', id);
           url += '/' + this.name + '.zip?attachment=true&alf_ticket=' + token;
         
          this.dialogRef.close(url);

          
        }

      });
  }
  

}
